import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import useQueryString from '@utils/useQueryString';
import ErrorBox from '@components/common/ErrorBox';
import Section from '@components/common/Section';
import { Form } from 'react-final-form';
import createDecorator from 'final-form-focus';
import formutils from '@utils/formutils';
import api from '@utils/api';
import { BAA } from '@utils/constants';
import Button from '@ui/button/Button';
import BookAnAppointmentStoreSelector from './BookAnAppointmentStoreSelector';
import LiveBoutiqueModal from './LiveBoutiqueModal';
const LoginModal = React.lazy(() => import('@components/login/LoginModal'));
const focusOnError = createDecorator(); // must be outside the component
const LiveBoutique = (props) => {
    const { t } = useTranslation();
    const [initialValues, setInitialValues] = useState();
    const [errors, setErrors] = useState([]);
    const [formdef, setFormdef] = useState();
    const [store, setStore] = useState(props.store);
    const [storeID, setStoreID] = useQueryString('storeID');
    const [showLiveBoutiqueModal, setShowLiveBoutiqueModal] = useQueryString('openLiveBoutique', false, true);
    useEffect(() => {
        let val = {};
        api.getForm('live-boutique-stores', val, true).then((data) => {
            setInitialValues(val);
            setFormdef(data);
        });
    }, []);
    useEffect(() => {
        if (storeID) {
            api.searchStoreDetails(storeID).then((data) => {
                setStore(data);
            });
        }
    }, []);
    const validate = async (values) => {
        return await formutils.validateForm(values, formdef, 'live-boutique-stores');
    };
    const onSubmit = async (values) => {
        setErrors([]);
        let err = await validate(values);
        if (err && Object.keys(err).length > 0) {
            return err;
        }
        setShowLiveBoutiqueModal(true);
    };
    if (!formdef) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement("div", { className: "client-service account-appointments" },
        React.createElement(Section, { introSection: true, title: t('bookanappointment.liveboutique'), description: t('liveboutique.intro') }),
        React.createElement("div", { className: "product-reserve__detail__form scrollable" },
            React.createElement(Form, { initialValues: initialValues, onSubmit: onSubmit, validate: validate, decorators: [focusOnError], mutators: { global: formutils.globalMutator }, render: ({ handleSubmit, form, submitting, pristine, values }) => (React.createElement("form", { onSubmit: handleSubmit },
                    React.createElement(React.Fragment, null,
                        React.createElement(BookAnAppointmentStoreSelector, Object.assign({ formdef: formdef, initialValues: initialValues }, props, { mutator: form.mutators.global, store: store, onSelect: setStore, liveBoutique: true, appointmentType: BAA.APPOINTMENT.VIRTUAL }))),
                    store && (React.createElement("div", { className: "row" },
                        React.createElement("div", { className: "col-12 col-md-6 offset-md-6" },
                            React.createElement("div", { className: "product-reserve__detail__form__submit" },
                                React.createElement(Button, { type: "submit", disabled: submitting, cls: ['button--primary'] }, t('bookanappointment.confirmappointment')))))),
                    React.createElement(ErrorBox, { errors: errors }))) })),
        store && (React.createElement(LiveBoutiqueModal, Object.assign({ modalimage: window.loginImageFolder + 'bg-live-boutique.jpg', store: store, isOpen: showLiveBoutiqueModal }, props, { onRequestClose: () => setShowLiveBoutiqueModal(false) })))));
};
export default LiveBoutique;
